'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _breakpoints = require('./breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var exportable = {
  pointer: {
    cursor: 'pointer'
  },
  cursorDefault: {
    cursor: 'default'
  },
  positionRelative: {
    position: 'relative'
  },
  positionAbsolute: {
    position: 'absolute'
  },
  positionFixed: {
    position: 'fixed'
  },
  positionSticky: {
    position: 'sticky'
  },
  absoluteExpand: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0
  },
  fullHeight: {
    height: '100%'
  },
  fullWidth: {
    width: '100%'
  },
  opacity50: {
    opacity: 0.5
  },
  showSmDown: _defineProperty({}, '@media(min-width: ' + _breakpoints2.default.m + 'px)', {
    display: 'none'
  }),
  hideSm: _defineProperty({
    display: 'none'
  }, '@media(min-width: ' + _breakpoints2.default.m + 'px)', {
    display: 'inherit'
  }),
  showMdUp: _defineProperty({}, '@media(max-width: ' + (_breakpoints2.default.m - 1) + 'px)', {
    display: 'none'
  }),
  showXlUp: _defineProperty({}, '@media(max-width: ' + (_breakpoints2.default.xl - 1) + 'px)', {
    display: 'none'
  }),
  showLgDown: _defineProperty({}, '@media(min-width: ' + _breakpoints2.default.xl + 'px)', {
    display: 'none'
  }),
  showMd: _defineProperty({
    display: 'none'
  }, '@media(min-width: ' + _breakpoints2.default.m + 'px) and (max-width: ' + _breakpoints2.default.l + 'px)', {
    display: 'inherit'
  }),
  showMdDown: _defineProperty({}, '@media(min-width: ' + _breakpoints2.default.l + 'px)', {
    display: 'none'
  }),
  showLgUp: _defineProperty({}, '@media(max-width: ' + (_breakpoints2.default.l - 1) + 'px)', {
    display: 'none'
  }),
  showXxlUp: _defineProperty({}, '@media(max-width: ' + (_breakpoints2.default.xxl - 1) + 'px)', {
    display: 'none'
  }),
  listStyleTypeNone: {
    listStyleType: 'none'
  },
  displayNone: {
    display: 'none'
  },
  displayInlineBlock: {
    display: 'inline-block'
  },
  overflowScroll: {
    overflow: 'scroll'
  },
  overflowHidden: {
    overflow: 'hidden'
  },
  textOverflowEllipsis: {
    textOverflow: 'ellipsis'
  },
  textDecorationNone: {
    textDecoration: 'none'
  }
};
exports.default = exportable;